import { ConceptCode } from '@tiendanube/common/src/domains/billing/types';
import { BILLING_NEW_FLOW_FREQUENCY } from 'App/featuresFlags';
import { useHasTags } from 'App/hooks';
import { SubmitButton } from 'commons/components';
import { useToastStatus } from 'commons/hooks';
import { combineStatus } from 'commons/utils/combineStatus';
import {
  useGetRecurrentPaymentConcepts,
  usePaySingleCharge,
} from 'domains/Billing/Checkout/hooks';
import useTranslationBilling from 'domains/Billing/useTranslationBilling';

interface PayButtonProps {
  concept: ConceptCode;
  externalReference?: string | null;
}

export default function PayButton({
  concept,
  externalReference,
}: Readonly<PayButtonProps>) {
  const t = useTranslationBilling('checkout.paymentStatusAlert.payButton');
  const { onPay, setupStatus, executionStatus } = usePaySingleCharge(
    concept,
    externalReference || undefined,
  );
  const { recurrentPaymentForConcept, status: recurrentPaymentStatus } =
    useGetRecurrentPaymentConcepts();
  const [hasTag] = useHasTags(BILLING_NEW_FLOW_FREQUENCY);

  const { isSuccess: setupSuccess } = combineStatus(
    setupStatus.status,
    recurrentPaymentStatus,
  );

  useToastStatus({
    status: executionStatus.status,
    error: t('error'),
  });

  if (
    !setupSuccess ||
    (recurrentPaymentForConcept(concept, externalReference || undefined) &&
      !hasTag)
  )
    return null;

  return (
    <SubmitButton
      disabled={executionStatus.isLoading}
      isLoading={executionStatus.isLoading}
      onClick={onPay}
    >
      {t('button')}
    </SubmitButton>
  );
}
